import React, { useContext } from 'react';
import {  Button, Box } from '@mui/material';
import { Formik, Form, Field,} from 'formik';
import { SymptomDetailsContext } from '../../../../utilities/context.js'
import "../../../../css/report.css"

function StoryEditor(props)
{
const {story, setStory} = useContext(SymptomDetailsContext)
let initialValues = {storyText: story}
const onSubmit=(values)=>
   {
    setStory(values.storyText)
    props.handleClose()
   }

return(
    <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    >
   <Form>
    <Box sx={{border:"solid", borderColor:"grey.300",borderRadius:"10px", width:"auto", margin:1}}>
    <label htmlFor={"storyText"}> {"History"} </label>
    <p><Field as = 'textarea'className="textAreaInputBox" id={"storyText"}  name={"storyText"} /></p>
    </Box>
     <Button sx={{ m: 1 }} variant='contained' size="small" type='submit' >Save</Button>
    </Form>
  </Formik>

)



}

export default StoryEditor

